import React from 'react';
import { palette } from '../../style-utils/theme';

interface PlusButtonProps {
  color?: string;
}

/* DECORATION. This glyph always sits beside its own text label, so
   exposing it to the accessibility tree only adds a nameless graphic
   before every button that uses it. */
export const PlusButton: React.FC<PlusButtonProps> = ({
  color = palette.white,
}) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 6L12 18" stroke={color} strokeLinecap="round" />
      <path d="M18 12L6 12" stroke={color} strokeLinecap="round" />
    </svg>
  );
};
